/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import type { Facts } from '../index';

/**
 * Builds one layer of the evaluation fact chain: own facts shadow the
 * parent's via the prototype chain, giving spread-merge precedence (local
 * wins) without copying the parent.
 *
 * Layered facts are lookup-only. Spreading, enumerating or JSON-serialising
 * a layer sees only its own facts and silently drops everything inherited,
 * so consumers must access facts exclusively by key.
 */
export const createFactLayer = (parent: Facts | null, own: Facts): Facts => {
  return Object.assign(Object.create(parent ?? null), own);
};

/**
 * The layer a fact layer was built on, or null at the root. Defined only for
 * layers created by createFactLayer; callers must treat any other object's
 * prototype as no parent.
 */
export const parentLayerOf = (layer: Facts): Facts | null => {
  return Object.getPrototypeOf(layer);
};
